export const AccentIconSize = {
  small: 24,
  'small-medium': 36,
  'small-L': 40,
  'small-XL': 48,
  medium: 60,
  large: 80,
};
